export function Counter({
  label,
  value,
  money = false,
}: {
  label: string;
  value: string;
  money?: boolean;
}) {
  return (
    <div className="counter">
      <div className="counter-label">{label}</div>
      <div className={money ? "counter-value money" : "counter-value"}>{value}</div>
    </div>
  );
}
